module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Step 1/5")]), _vm._v(" "), (_vm.loader) ? _c('loader') : _c('a', {
    attrs: {
      "id": "upload"
    }
  }, [_vm._v("\n    Upload Profile Photo\n  ")]), _vm._v(" "), _c('img', {
    attrs: {
      "id": "photo"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-209d7c70","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadImage/uploadImage_1.vue
// module id = 830
// module chunks = 14